import { store } from 'store/configureStore';
import api from '../index';

interface ClientLogPayload {
  level: 'error' | 'warn' | 'info';
  context: string;
  message: string;
  metadata?: Record<string, unknown>;
}

const clientLogsApi = api.injectEndpoints({
  endpoints: builder => ({
    sendClientLog: builder.mutation<void, ClientLogPayload>({
      query: body => ({
        url: '/client-logs',
        method: 'POST',
        body
      })
    })
  })
});

export const { useSendClientLogMutation } = clientLogsApi;

export const sendClientLog = (payload: ClientLogPayload) => {
  store.dispatch(clientLogsApi.endpoints.sendClientLog.initiate(payload));
};

export default clientLogsApi;
